interface DocumentStatusBadgeProps {
  status?: string | null
}

const getStatusConfig = (status?: string | null) => {
  switch (status) {
    case 'ok':
      return { label: 'OK', className: 'badge-success' }
    case 'not-found':
      return { label: 'Not Found', className: 'badge-warning' }
    case 'error':
      return { label: 'Error', className: 'badge-error' }
    default:
      return { label: status || 'Pending', className: 'badge-ghost' }
  }
}

const DocumentStatusBadge = ({ status }: DocumentStatusBadgeProps) => {
  const config = getStatusConfig(status)

  return (
    <span className={`badge badge-sm ${config.className}`}>{config.label}</span>
  )
}

export { DocumentStatusBadge }
